// extracted by mini-css-extract-plugin
export default {"wrapper":"PlayerWidgets_wrapper__9vAsh","dimensions":"PlayerWidgets_dimensions__RRKOm","save":"PlayerWidgets_save__eEGi4"};